import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { MyInfo } from "../../models/polymer/MyInfo.model";
import { API_MyInfo, API_MyInfo_AccessToken, API_RenewToken, API_Spcp_AccessToken } from "../../utils/api";
import { PolymerAxios } from "../../utils/axios";
import { UserInfo } from "../../models/polymer/UserInfo.model";
import moment from "moment";
import { RenewToken } from "../../models/polymer/RenewToken.model";
import config from "../../config";
import data from "../../../src/utils/shared/dummy.json";
import { DropdownItemInterface } from "../../models/interfaces/dropdown-item.interface";
import { PolymerCrypto } from "../../utils/encryptor";

let demoMyinfos: DropdownItemInterface[] = data.singpassMyInfo;

export interface AuthenticationStates {
  isAuthenticated: boolean;
  loginUser: MyInfo; //This are used when in singpass login page. //This maybe remove in the future.

  retrieveFromMyInfo: boolean | null;
  retrieveFromMyInfoDeclaration: boolean | null;
  myInfoData: MyInfo; //This are used when myinfo are prompt in start application page
  structureStatus: string; //To track whether login user is retaining/outgoing

  singpassToken: string | undefined;
  expiredIn: number | undefined;
  isSingPass: boolean;

  spcpName: string;
}

const initialState: AuthenticationStates = {
  isAuthenticated: false,
  loginUser: new MyInfo(),

  retrieveFromMyInfo: null,
  retrieveFromMyInfoDeclaration: null,
  myInfoData: new MyInfo(),
  structureStatus: "",
  
  singpassToken: undefined,
  expiredIn: undefined,
  isSingPass: false,

  spcpName: ""
};

const AuthenticationSlice = createSlice({
  name: "Authentication Slice",
  initialState,
  reducers: {
    updateStructureStatus: (state, action: PayloadAction<string>) => {
      state.structureStatus = action.payload;
    },
    resetRetrieveFromMyInfo: (state, action: PayloadAction<boolean>) => {
      state.retrieveFromMyInfo = action.payload;
    },
    resetRetrieveFromMyInfoDeclaration: (state, action: PayloadAction<boolean>) => {
      state.retrieveFromMyInfoDeclaration = action.payload;
    },
    updateSingpassToken: (state, action: PayloadAction<string>) => {
      console.log("DEBUG - set singpass Token", action.payload);
      state.singpassToken = action.payload;
    },
    updateExpiredIn: (state, action: PayloadAction<number | undefined>) => {
      state.expiredIn = action.payload;
    },

    resetAuthData: (state) => {
      state.isAuthenticated = false;
      state.loginUser = new MyInfo();
      state.spcpName = "";
      state.retrieveFromMyInfo = null;
      state.retrieveFromMyInfoDeclaration = null;
      state.myInfoData = new MyInfo();
      state.structureStatus = "";
      state.singpassToken = undefined;
      state.expiredIn = undefined;
      state.isSingPass = false;
      localStorage.clear();
      caches.keys().then((names) => {
        names.forEach((name) => {
            caches.delete(name);
        });
      });
      sessionStorage.clear();
      window.localStorage.clear();
      window.sessionStorage.clear();
      const cookies = document.cookie.split(";");
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf("=");
        const name = eqPos > -1 ? cookie.substring(0, eqPos) : cookie;
        const newCookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/";
        document.cookie = newCookie;
      }
    },
    resetSingPassAuthData: (state) => {
      state.loginUser = new MyInfo();
      state.spcpName = "";
      state.retrieveFromMyInfo = null;
      state.retrieveFromMyInfoDeclaration = null;
      state.myInfoData = new MyInfo();
      state.structureStatus = "";
      state.singpassToken = undefined;
      state.expiredIn = undefined;
    },
  },

  extraReducers: (builder) => {
    builder.addCase(authenticateUserByNRIC.fulfilled, (state, action) => {
      state.loginUser = { ...new MyInfo(action.payload) };
      state.isAuthenticated = true;
    });
    builder.addCase(authenticateUserByNRIC.rejected, (state, action) => {
      state.loginUser = { ...new MyInfo() };
      state.isAuthenticated = false;
    });
    builder.addCase(assignNRICforSingpassLogin.fulfilled, (state, action) => {
      state.isAuthenticated = true;
      state.isSingPass = true;
    });
    builder.addCase(assignNRICforSingpassLogin.rejected, (state, action) => {
      state.isAuthenticated = false;
      state.isSingPass = false;
    });
    builder.addCase(retrieveMyInfoByNRIC.fulfilled, (state, action) => {
      const email = PolymerCrypto.decryption(action.payload?.email);
      const mobile_no = PolymerCrypto.decryption(action.payload?.mobile_no);
      const uinfin = PolymerCrypto.decryption(action.payload?.uinfin);

      state.myInfoData = { ...new MyInfo({...action.payload, email,mobile_no, uinfin} ) };
      state.retrieveFromMyInfo = true;
    });
    builder.addCase(retrieveMyInfoByNRIC.rejected, (state, action) => {
      state.myInfoData = { ...new MyInfo() };
      state.retrieveFromMyInfo = false;
    });
    builder.addCase(retrieveMyInfoByNRICDeclaration.fulfilled, (state, action) => {
      const email = PolymerCrypto.decryption(action.payload?.email);
      const mobile_no = PolymerCrypto.decryption(action.payload?.mobile_no);
      const uinfin = PolymerCrypto.decryption(action.payload?.uinfin);

      state.myInfoData = { ...new MyInfo({...action.payload, email,mobile_no, uinfin} ) };
      state.retrieveFromMyInfoDeclaration = true;
    });
    builder.addCase(retrieveMyInfoByNRICDeclaration.rejected, (state, action) => {
      state.myInfoData = { ...new MyInfo() };
      state.retrieveFromMyInfoDeclaration = false;
    });
    builder.addCase(authenticateUserBySingpassToken.fulfilled, (state, action) => {
      
      const email = PolymerCrypto.decryption(action.payload?.email);
      const mobile_no = PolymerCrypto.decryption(action.payload?.mobile_no);
      const uinfin = PolymerCrypto.decryption(action.payload?.uinfin);

      state.loginUser = { ...new MyInfo({...action.payload, email,mobile_no, uinfin} ) };
      state.isAuthenticated = true;
      state.isSingPass = true;
    });
    builder.addCase(authenticateUserBySingpassToken.rejected, (state, action) => {
      state.loginUser = { ...new MyInfo() };
      state.isAuthenticated = false;
      state.isSingPass = false;
    });
    builder.addCase(getSpcpName.fulfilled, (state, action) => {
      console.log("action payload",action.payload);
      console.log("action payload spcpname",action.payload.spcp_name);
      state.spcpName = action.payload.spcp_name;
    });
    builder.addCase(getSpcpName.rejected, (state, action) => {
      state.spcpName = "";
    });
    builder.addCase(renewTokenForSingpassLogin.fulfilled, (state, action) => {
      const {code, expires_in} = action.payload as RenewToken;
      console.log("expires_in: ", expires_in);
      state.singpassToken = code;
      state.expiredIn = (Number(expires_in))/1000;
      // state.expiredIn = moment().add(Number(expires_in), 'milliseconds').unix();
    });
    builder.addCase(renewTokenForSingpassLogin.rejected, (state, action) => {
      // if(!config.isLocalhost){
      //   AuthenticationSlice.caseReducers.resetAuthData(state);
      // }
    });
  },
});

export const { updateStructureStatus, resetAuthData, resetSingPassAuthData, resetRetrieveFromMyInfoDeclaration,updateExpiredIn, resetRetrieveFromMyInfo, updateSingpassToken } = AuthenticationSlice.actions;

export default AuthenticationSlice.reducer;

//NOTE CHANGE API, DYNAMIC UINFIN
export const authenticateUserByNRIC = createAsyncThunk(
  "authenticateUserByNRIC",
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { uinfin } = args;

    const isDynamic = demoMyinfos.find(e=>e.value === uinfin)?.dynamic;
    
    if(isDynamic ){
      // return await PolymerAxios('', config.byPassSingpassToken)
      // .get(`${API_Mock_MyInfo}/${uinfin}`)
      // .then((res) => {
      //   if (res.status === 200) {
      //     return fulfillWithValue(res.data);
      //   } else {
      //     return rejectWithValue(res.status);
      //   }
      // })
      // .catch((e) => {
      //   return rejectWithValue(e.response.status);
      // });
      return {
        uinfin: uinfin,
        name: `${uinfin}`,
        residential_status: 'C',
        dob: '1980-12-17',
        mobile_no: '00001111',
        email: 'michael-isDynamic@gmail.com',
        race: 'C',
        nationality: 'SG',
        sex: 'M',
        marital_status: "S"
      }
    }
    else{
  
      // return await axios
      //   .get(`${SWAGGER_BASEURL}/myinfo/${uinfin}`)
      //   .then((res) => {
      //     if (res.status === 200) {
      //       return fulfillWithValue(res.data);
      //     } else {
      //       return rejectWithValue(res.status);
      //     }
      //   })
      //   .catch((e) => {
      //     return rejectWithValue(e.response.status);
      //   });
    }
  }
);



const handleCreateAsyncThunk = (name: string) => createAsyncThunk(
  name,
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { uinfin, singpass_code, allow_my_info } = args;
    if (allow_my_info) {
      return await  PolymerAxios(uinfin, singpass_code)
        .get(`${API_MyInfo}`)
        .then((res) => {
          if (res.status === 200) {
            return fulfillWithValue(res.data);
          } else {
            return rejectWithValue(res.status);
          }
        })
        .catch((e) => {
          return rejectWithValue(e.response.status);
        });
    } else {
      return rejectWithValue(false);
    }
  }
)


//NOTE: THIS IS SINGPASS LOGIN 
export const authenticateUserBySingpassToken = createAsyncThunk(
  "authenticateUserBySingpassToken",
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { singpass_code } = args;
    
    // const user_info:UserInfo = await PolymerAxios('',singpass_code).get(`${API_UserInfo}`).then(res=>res.data);
    // if(user_info?.uinfin){
      return await PolymerAxios('', singpass_code).get(`${API_MyInfo_AccessToken}`)
        .then((res) => {
          if (res.status === 200) {
            const myinfo_data = JSON.parse(JSON.stringify(res.data));
            return fulfillWithValue(myinfo_data);
          } else {
            return rejectWithValue(res.status);
          }
        })
        .catch((e) => {
          return rejectWithValue(e.response.status);
        });
    // }
    // else{
    //   return rejectWithValue(401);
    // }
   
  }
);

export const getSpcpName = createAsyncThunk(
  "getSpcpName",
  async (args: any, { fulfillWithValue, rejectWithValue }) => {
    const { singpass_code } = args;
    
      return await PolymerAxios('', singpass_code).get(`${API_Spcp_AccessToken}`)
        .then((res) => {
          if (res.status === 200) {
            const spcp_data = JSON.parse(JSON.stringify(res.data));
            console.log("API_Spcp_AccessToken status 200: ", spcp_data);
            console.log("API_Spcp_AccessToken status 200: ", res.data);
            return fulfillWithValue(spcp_data);
          } else {
            console.log("API_Spcp_AccessToken status failed ");
            return rejectWithValue(res.status);
          }
        })
        .catch((e) => {
          return rejectWithValue(e.response.status);
        });
  }
);

export const assignNRICforSingpassLogin = createAsyncThunk(
  "assignNRICforSingpassLogin",
  async (args:any, { fulfillWithValue, rejectWithValue }) => {
    return fulfillWithValue(true);
  }
);

export const renewTokenForSingpassLogin = createAsyncThunk(
  "renewTokenForSingpassLogin",
  async (args:any, { fulfillWithValue, rejectWithValue }) => {
    const { singpass_code } = args;
    return await PolymerAxios('',singpass_code).get(`${API_RenewToken}`).then(res=>{
      console.log("RENEW CATCH",res.data, res.status);
      if(res.status === 200){
        return fulfillWithValue(res.data);
      }
      else if(res.status === 401){  
        console.log("RENEW FAILED");
        return rejectWithValue(401);
      }
    }).catch((e)=>{
      console.log("RENEW CATCH",e);
      return rejectWithValue(500);
    });
  }
);




export const retrieveMyInfoByNRIC = handleCreateAsyncThunk("retrieveMyInfoByNRIC");
export const retrieveMyInfoByNRICDeclaration = handleCreateAsyncThunk("retrieveMyInfoByNRICDeclaration");
